import { render, staticRenderFns } from "./m_chat.vue?vue&type=template&id=36a65941&scoped=true&"
import script from "./m_chat.vue?vue&type=script&lang=js&"
export * from "./m_chat.vue?vue&type=script&lang=js&"
import style0 from "./m_chat.vue?vue&type=style&index=0&id=36a65941&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a65941",
  null
  
)

export default component.exports